import { all, put, call, takeLatest } from 'redux-saga/effects'
import { ApiError, RequestStatus } from 'features/common'
import { updatesRequest } from './developersSlice'
import { addUpdates, setUpdatesError, setUpdatesStatus } from './developersSlice'
import { getUpdates } from '../api/developers'

function removeMarkdownHeader(markdownWithHeader) {
  const separator = '---\n'
  const secondSeparatorIndex = markdownWithHeader.slice(separator.length).indexOf(separator)
  const markdownWithoutHeader = markdownWithHeader.slice(secondSeparatorIndex + 2 * separator.length)
  return markdownWithoutHeader
}

function* fetchUpdatesMarkdown() {
  try {
    yield put(setUpdatesStatus(RequestStatus.Pending))
    const developersMarkdownWithHeader: string = yield call(getUpdates)
    const developersMarkdown = removeMarkdownHeader(developersMarkdownWithHeader)
    yield put(addUpdates(developersMarkdown))
    yield put(setUpdatesStatus(RequestStatus.Fulfilled))
  } catch (e) {
    yield put(setUpdatesStatus(RequestStatus.Rejected))
    yield put(setUpdatesError(e as ApiError))
  }
}

export function* watchDevelopers() {
  yield takeLatest(updatesRequest.type, fetchUpdatesMarkdown)
}

export default function* developersSaga() {
  try {
    yield all([watchDevelopers()])
  } catch (e) {
    // TODO
  }
}
